import { AuthorizedClient } from '~/app-modules/core/clients/authorized-client';
import { HttpConnection } from '~/app-modules/core/clients/http-connection';
import { AuthService } from '~/app-modules/auth/services/auth-service';
import { CurrentUserDto } from '~/app-modules/user/clients/dto/current-user.dto';
import { UserStore } from '~/app-modules/user/stores/user.store';

@singleton()
export class AuthUserClient extends AuthorizedClient {
  constructor(http: HttpConnection, authService: AuthService, userStore: UserStore) {
    super(http, authService, userStore);
  }

  /**
   *  Получение информации о текущем юзере
   */
  async getCurrentUser() {
    return await this.executeRequest(
      {
        method: 'get',
        url: '/ui/v1/auth/user/current',
      },
      CurrentUserDto,
    );
  }
}
